import { useLocation } from 'react-router-dom';
import { css } from '@emotion/core';
import { faSignOutAlt } from '@fortawesome/pro-regular-svg-icons/faSignOutAlt';
import { IconButton } from '@veeva/corgix/button';
import Tooltip from '@veeva/corgix/tooltip';
import SiteLogo from '../../images/site-logo.svg';
import useMessageService from '../../services/i18n/useMessageService';
import HeaderTabList from './HeaderTabList';
import logout from '../../services/logout';
import { AuthenticatedPaths } from '../../constants/Paths';

const Header = () => {
    const { pathname } = useLocation();
    const [[logoutLabel = 'Log Out']] = useMessageService(['general.logout']);

    const handleLogoutClick = () => {
        logout();
    };

    const headerCss = css`
        background-color: #223354;
        height: 4.25rem;
        display: flex;
        align-items: center;
        padding: 0 1rem;

        button:not([disabled]) {
            border-radius: 100%;
            background-color: transparent;
            width: 3.667rem;
            height: 3.667rem;
            color: #ffffff;
            display: inline-block;
            margin-left: auto;

            svg {
                width: 2.333rem;
                height: 2.333rem;
                cursor: pointer;
                color: #ffffff;
            }

            &:hover,
            &:focus {
                background-color: rgba(255, 255, 255, 0.2);

                > svg:first-of-type {
                    color: #ffffff;
                }
            }

            &:active {
                background-color: rgba(255, 255, 255, 0.3);
            }
        }
    `;

    if (pathname === AuthenticatedPaths.VAULT_INVITES) {
        return <></>;
    }

    return (
        <div css={headerCss}>
            <div
                css={css`
                    display: flex;
                    gap: 3rem;
                    align-items: center;
                    height: 100%;
                `}
            >
                <img
                    css={css`
                        width: 12.5rem;
                        height: 2.167rem;
                    `}
                    src={SiteLogo}
                    alt="VeevaID"
                />
                <HeaderTabList />
            </div>
            <div
                css={css`
                    flex-grow: 1;
                `}
            />
            <Tooltip placement="bottom" content={logoutLabel}>
                <IconButton onClick={handleLogoutClick} icon={faSignOutAlt} />
            </Tooltip>
        </div>
    );
};

export default Header;
